
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/transporters/[[...params]]",
      function () {
        return require("private-next-pages/transporters/[[...params]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/transporters/[[...params]]"])
      });
    }
  